import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { selectUser, startLoadingUsersPaginated, startSearchingUsersPaginated, userStartDelete } from "../../app/actions/userActions";

import Pagination from "../generic-ui/Pagination";

import Select from "../generic-ui/Select";
import { colsComponent } from "../../app/data/adminUserRoles";

import TableAppComponent from "./TableAppComponent";
import SearchBackComponent from "./SearchBackComponent";
import { debugLogPages } from "../../app/helpers/debugHelper";

const listOptions = [2, 3, 4, 5, 10, 15, 20, 25, 50, 100];

const ListUserComponent = () => {
  debugLogPages(":: ListUserComponent");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { searchTextState, usersS, usersP, totalPagesP, totalItemsP, currentPageP, totalPagesS, totalItemsS, currentPageS } = useSelector(
    (state) => state.user
  );

  const [, setCurrentPageClick] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageInitial] = useState(0);
  const [searchText, setSearchText] = useState(searchTextState || "");

  useEffect(() => {
    dispatch(startLoadingUsersPaginated(pageInitial, itemsPerPage));
    
  }, []);

  const onEditRow = (row) => {
    dispatch(selectUser(row));
    if (usersS?.length > 0) {
      navigate("/admin-user/edit-user", {
        state: { searchTextNavListUser: searchText },
      });
    } else {
      navigate("/admin-user/edit-user");
    }
  };

  const onSelectRow = (row) => {
    
    dispatch(userStartDelete(row.id));
  };

  const onPageChange = (pageClick) => {
    if (usersS?.length > 0) {
      dispatch(startSearchingUsersPaginated(searchText, pageClick - 1, itemsPerPage));
    } else {
      dispatch(startLoadingUsersPaginated(pageClick - 1, itemsPerPage));
    }
    setCurrentPageClick(pageClick);
  };

  const onChangeSelect = (event) => {
    setItemsPerPage(event.target.value);
    if (usersS?.length > 0) {
      dispatch(startSearchingUsersPaginated(searchText, 0, event.target.value));
    } else {
      dispatch(startLoadingUsersPaginated(0, event.target.value));
    }
    setCurrentPageClick(0);
    setItemsPerPage(event.target.value);
  };

  /*
  const configSearch = getConfigurationByIdField(
    "front.table.search",
    configurations
  );
  */

  return (
    <>
      <SearchBackComponent searchText={searchText} setSearchText={setSearchText} itemsPerPage={itemsPerPage} />

      <hr className="line-hr" />

      {usersS?.length > 0 ? (
        <TableAppComponent cols={colsComponent} data={usersS} onEditRow={onEditRow} onSelectRow={onSelectRow} />
      ) : (
        <TableAppComponent cols={colsComponent} data={usersP} onEditRow={onEditRow} onSelectRow={onSelectRow} />
      )}

      <div>
        <Select
          listOptions={listOptions}
          onChangeSelect={onChangeSelect}
          
          pageSize={itemsPerPage}
        />
      </div>

      <div className="pagination justify-content-center">
        {usersS?.length > 0 ? (
          <Pagination
            totalPages={totalPagesS}
            totalItems={totalItemsS}
            currentPage={currentPageS + 1} 
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
          />
        ) : (
          <Pagination
            totalPages={totalPagesP}
            totalItems={totalItemsP}
            currentPage={currentPageP + 1} 
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
          />
        )}
      </div>
    </>
  );
};

export default ListUserComponent;
